module.exports = __webpack_public_path__ + "img/qr.b116274b.jpg";